import AdvertisementConfig from './AdvertisementConfig.js'
import AdProvider_Admob from './AdProvider_Admob_Plus.js'
import AdProvider_Facebook from './AdProvider_Facebook.js'
import AdProvider_GoogleH5 from './AdProvider_GoogleH5.js'
export default class Advertisement {
    constructor(config) {
        this.config = config || AdvertisementConfig;
        this.removeAds = false;
        this.lastShownInterstitial = null;
        this.lastShownRewarded = null;
        this.onAdRewarded = null;
        this.onAdLoaded = null;
        this.onAdOpened = null;
        this.onAdError = null;
        this.dProvider = null;
    }
    getOS() {
        let ua = navigator.userAgent;
        let isCordova = typeof cordova != "undefined";

        //var url = window && window.location && window.location.href && window.location.href || "";
        if (typeof FBInstant !== "undefined") {
            return "FBMessenger";
        }

        if (/(Windows Phone.*MSAppHost\/3.0)/i.test(navigator.appVersion)) {
            // Windows 10 UWP
            return "windowsPhone";
        }
        if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
            // Windows 10 UWP
            return "windows";
        }

        let isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);
        if (isCordova && /(android)/i.test(navigator.userAgent) && isKindle) {
            return "amazon";
        }
        if (isCordova && /(android)/i.test(navigator.userAgent) && !isKindle) {
            return "android";
        }
        if (isCordova && (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel')) {
            return "ios";
        }

        return "web";
    }
    async setUp() {

        const config = this.config;
        //Dont remove reward ads
        ////only load/show if ads enabled
        //if (Advertisement.removeAds) return;

        //setup only once, there are event that get wired up
        if (this.isSetup) return;

        this.isSetup = true;


        //chose provider and ad ids based on OS 
        var os = this.getOS();

        if (os === "android" || os === "amazon") {
            this.adProvider = new AdProvider_Admob(
                config.admobAppId_Android
                , config.admobInterstitialAdId_Android
                , config.admobRewardedAdId_Android
                , config.admobAppOpenAdId_Android
                , this.adLoaded.bind(this)
                , this.adOpened.bind(this)
                , this.adClosed.bind(this)
                , this.adError.bind(this)
            );
            this.adProvider.setup();
        }
        else if (os === "ios") {
            if (typeof device !== 'undefined' && device.version && device.version.startsWith("12")) {
                console.log(`ios 12 has a bug - can not click ad; Skip showing ad`);

            } else {
                this.adProvider = new AdProvider_Admob(
                    config.admobAppId_iOS
                    , config.admobInterstitialAdId_iOS
                    , config.admobRewardedAdId_iOS
                    , config.admobAppOpenAdId_iOS
                    , this.adLoaded.bind(this)
                    , this.adOpened.bind(this)
                    , this.adClosed.bind(this)
                    , this.adError.bind(this)
                );
                this.adProvider.setup();
            }
        }
        else if (os === "FBMessenger") {
            this.adProvider = new AdProvider_Facebook(
                config.facebookAdId_interstital
                , config.facebookAdId_reward
                , this.adLoaded.bind(this)
                , this.adOpened.bind(this)
                , this.adClosed.bind(this)
                , this.adError.bind(this)
            );
            this.adProvider.setup();
        }
        else if (os === "web") {
            this.adProvider = new AdProvider_GoogleH5(
                config.googleH5_ad_client
                , config.googleH5_ad_channel
                , this.adLoaded.bind(this)
                , this.adOpened.bind(this)
                , this.adClosed.bind(this)
                , this.adError.bind(this)
            );
            this.adProvider.setup();
        }
        else if (os === "windows") {
            this.adProvider = new AdProvider_GoogleH5(
                config.googleH5_ad_client
                , config.googleH5_ad_channel
                , this.adLoaded.bind(this)
                , this.adOpened.bind(this)
                , this.adClosed.bind(this)
                , this.adError.bind(this)
            );
            await this.adProvider.setup();
        }
        else if (os === "windowsPhone") {
            this.adProvider = new AdProvider_GoogleH5(
                config.googleH5_ad_client
                , config.googleH5_ad_channel
                , this.adLoaded.bind(this)
                , this.adOpened.bind(this)
                , this.adClosed.bind(this)
                , this.adError.bind(this)
            );
            await this.adProvider.setup();
        }
        if(!this.adProvider){
            //todo: default to admob and let admob figure  out if it is ios or android
            this.removeAds = true;
            this.isSetup = true;
            console.log(os + ' platform is not supported'); return;
        }

    };
    tryShowInterstitialAd() {
        const config = this.config;
        //0. if ads removed, dont even load the ad
        //1. only allow ad to be shown/loaded once every 150 second (Advertisement.delayBetweenAds)
        //2. check if over 20 min, may have not been in the app and reopened it with out restarting 
        //3. load ad ether way
        //4. show ad if conditions met

        //only load/show if ads enabled
        if (this.removeAds) return;

        var readyToShowAd = false;

        //reset timer
        if (this.lastShownInterstitial === null) {
            this.lastShownInterstitial = Date.now();//now
            //add start offset delay
            var newDate = new Date();
            newDate.setSeconds(newDate.getSeconds() - config.offsetStartdelay);
            this.lastShownInterstitial = newDate;
        }

        var secondsSinceLastAd = (Date.now() - this.lastShownInterstitial) / 1000;
        //check for  delayBetweenAds seconds passed
        if (secondsSinceLastAd > config.delayBetweenAds) {
            readyToShowAd = true;
        }
        //check if over 20 min, may have not been in the app and reopened it with out restarting 
        if (secondsSinceLastAd > config.awayResetTime) {
            readyToShowAd = false;
            this.lastShownInterstitial = Date.now();//now, reset
        }

        console.log("readyToShowInterstitialAd: " + readyToShowAd + " : " + secondsSinceLastAd + " of " + config.delayBetweenAds);

        // show ad or just load ad
        if (readyToShowAd) {
            this.showInterstitialAd();
        } else {
            this.loadInterstitialAd();
        }
    };
    loadInterstitialAd(forceShow) {
        if (this.adProvider) this.adProvider.loadAd();
    };
    showInterstitialAd() {
        if (this.adProvider) this.adProvider.showAd();
    };
    tryLoadRewardedAd() {
        const config = this.config;
        //1. allow first load to start after 0 minute 
        //2. allow rewarded ad to be shown/loaded once every 60000 (10 min)

        // //only load/show if ads enabled
        // if (this.removeAds) return;
        var readyToLoadAd = false;


        //allow no last time found - set date back a day
        if (this.lastShownRewarded === null) {
            this.lastShownRewarded = new Date().setTime(Date.now() - 86400000); //1 days = 86400000 ;
        }

        //check for 60000 seconds passed 
        var secondsSinceLastRewardedAd = (Date.now() - this.lastShownRewarded) / 1000;
        if (secondsSinceLastRewardedAd > config.delayBetweenRewardedAds) {
            readyToLoadAd = true;
        }

        console.log("readyToShowRewardedAd: " + readyToLoadAd + " : " + secondsSinceLastRewardedAd + " of " + config.delayBetweenRewardedAds);

        if (readyToLoadAd) {
            this.loadRewardedAd();
        }
    };
    loadRewardedAd() {
        if (this.adProvider) this.adProvider.loadRewardedAd();
    };
    showRewardedAd() {
        if (this.adProvider) this.adProvider.showRewardedAd();
    };
    async showAppOpenAd() {
        if (this.adProvider && this.adProvider.showAppOpenAd) {
            await this.adProvider.showAppOpenAd();
        }
    };
    async showAppOpenAdWithMaxDelay(maxDelay) {
        if (!maxDelay) maxDelay = 4000;
        let timeoutPromise = null;
        return new Promise(async (resolve, reject) => {
            if (this.adProvider && this.adProvider.showAppOpenAd) {
                timeoutPromise = setTimeout(() => {
                    //stop ad from showing
                    if (this.adProvider) this.adProvider.appOpenAdAutoShow = false;
                    reject(new Error('showAppOpenAd has not fired after 4 seconds. Skipping ad'));
                }, maxDelay);
                await this.adProvider.showAppOpenAd();
                clearTimeout(timeoutPromise);
                resolve();
            }
            else {
                reject();
            }
        });
    }
    showMediationTestSuite() {
        if (this.adProvider && this.adProvider.showMediationTestSuite) {
            this.adProvider.showMediationTestSuite();
        }
    };
    showAdInspector() {
        if (this.adProvider && this.adProvider.showAdInspector) {
            this.adProvider.showAdInspector();
        }
    };
    isInterstitialAdLoaded() {
        if (!this.adProvider) return false;
        return this.adProvider.isAdLoaded();
    };
    isRewardedAdLoaded() {
        if (!this.adProvider) return false;
        return this.adProvider.isRewardedAdLoaded();
    };
    isAppOpenAdLoaded() {
        if (!this.adProvider) return false;
        return this.adProvider.isAppOpenAdLoaded();
    };
    adLoaded(data) {
        //only allow rewarded ad to be loaded once per timer
        if (data && data.adType === "rewarded") {
            this.lastShownRewarded = Date.now();
        }
    };
    adOpened(data) {
        if (data && data.adType === "interstitial") {
            this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
        }
        if (data && data.adType === "rewarded") {
            this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
            this.lastShownRewarded = Date.now();
        }
    };
    adClosed(data) {
        if (data && data.adType === "interstitial") {
            this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
        }
        if (data && data.adType === "rewarded") {
            this.lastShownInterstitial = Date.now(); //reset interstitial timer for either ad
            this.lastShownRewarded = Date.now();
            if (data.rewardAmount) {
                if (this.onAdRewarded) {
                    this.onAdRewarded(data.rewardAmount, data.rewardType);
                }
            }
        }
    };
    adError(data) {
        if (this.onAdError) {
            this.onAdError(data.error, data.adType);
        }
    };
}